function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.25 16.5C1.25 17.1914 1.80859 17.75 2.5 17.75H17.5C18.1914 17.75 18.75 17.1914 18.75 16.5V5.25H1.25V16.5ZM7.5 8.21875C7.5 7.96094 7.71094 7.75 7.96875 7.75H12.0312C12.2891 7.75 12.5 7.96094 12.5 8.21875V8.53125C12.5 8.78906 12.2891 9 12.0312 9H7.96875C7.71094 9 7.5 8.78906 7.5 8.53125V8.21875ZM18.75 0.25H1.25C0.558594 0.25 0 0.808594 0 1.5V3.375C0 3.71875 0.28125 4 0.625 4H19.375C19.7188 4 20 3.71875 20 3.375V1.5C20 0.808594 19.4414 0.25 18.75 0.25Z",
  fill: "black"
});

var SvgArchive = function SvgArchive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArchive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/archive.090a629f.svg";
export { ForwardRef as ReactComponent };